const pageTitle = {
  Shopback: 'SHOPBACK',
  Apps: 'Apps',
  'App Store': 'App Store',
};

export default pageTitle;
